import { useMediaQuery } from '@mui/material'
import { useContext, useMemo } from 'react'
import ApplicationContext from '@platform/react/context/application'
import CellHOC from '@platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'

/**
 * Custom styles for the component.
 */
const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    justifyContent: 'center',
  },
})

/**
 * Returns the translated device's notRegisteredYet label.
 *
 * @returns {string}  the notRegisteredYet label
 */
export const notRegisteredLabel = () => {
  const { intl } = useContext(ApplicationContext)
  return intl._t(
    'label.notRegisteredYet',
    {
      ns: 'device',
      _key: 'label.notRegisteredYet',
      defaultValue: 'Not registered, yet',
    },
  )
}

/**
 * ListItemCellInstalledAtOrNotRegistered element.
 *
 * Displays a summary of the ServiceItem's installedAt organisation or a label stating that it has
 * not yet been installed.
 *
 * @param {Object} classes  element's style classes
 * @param {Object} props    element's properties
 *
 * @returns {React.JSX.Element}
 */
const ListItemCellDeviceInstalledAtOrNotRegistered = (classes, props = {}) => {
  const { intl } = useContext(ApplicationContext)

  const {
    installedAt: {
      value: {
        name,
        address,
      } = {},
    } = {},
  } = props

  const isXs = useMediaQuery(t => t.breakpoints.down('sm'))
  const addressSummary = intl.address(isXs ? { city: address?.city } : address, { inline: true })
  const notRegistered = notRegisteredLabel()

  return name ? (
    <>
      <Text
        value={name}
        align={'left'}
        color={'black'}
        variant={'14/bold'}
        maxLines={isXs ? 1 : 0}
      />
      <Text
        align={'left'}
        color={'gray.600'}
        variant={'12/regular'}
        value={addressSummary}
        maxLines={isXs ? 1 : 0}
      />
    </>
  ) : (
    <Text
      maxLines={0}
      align={'left'}
      color={'error'}
      variant={'14/bold'}
      value={notRegistered?.toUpperCase?.()}
    />
  )
}

export default CellHOC(ListItemCellDeviceInstalledAtOrNotRegistered, styles)
